<template>
  <div class="sticky-header fixed">
    <div class="row">
      <div class="top-bar">
        <div class="tutorial">
          <a href="javascript:" @click="$emit('openVideo')"> > Tutorial </a>
        </div>
        <div class="account">
          <a href="javascript:">
            <i class="fa fa-user-circle"></i> Hi,
            {{ authUser.firstName ? authUser.firstName : authUser.fullName }}
            <i class="fa fa-angle-down"></i>
          </a>
          <ul class="account-dropdown__list">
            <li>
              <router-link
                :to="{
                  name: 'Settings',
                }"
              >
                <i class="fa fa-user-cog"></i>
                My Account
              </router-link>
            </li>
            <li>
              <router-link
                :to="{
                  name: 'SavedCollections',
                }"
              >
                <i class="fa fa-stars"></i>
                Saved Collections
              </router-link>
            </li>
            <li>
              <a href="javascript:" @click="logout"
                ><i class="fa fa-sign-out"></i> Log out
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div id="header">
      <div class="row">
        <div class="col-6">
          <img src="@/assets/images/logo.png" id="img-logo" alt="Footer Logo" />
        </div>
        <div class="col-6">
          <div class="menu">
            <div class="d-flex flex-column">
              <div id="menu-right">
                <ul class="nav justify-content-end">
                  <li class="nav-item">
                    <a class="nav-link font-size" href="#meterial">
                      MATERIALS
                    </a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link font-size" href="#product-configuration">
                      BUILD YOUR OWN
                    </a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link font-size" href="#why-scancom">
                      WHY SCANCOM
                    </a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link font-size" href="#frequent-questions">
                      FAQ
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="menu-mobile">
            <b-button v-b-toggle href="#example-sidebar" @click.prevent>
              <span
                v-b-toggle
                href="#example-sidebar"
                @click.prevent
                class="fa fa fa-bars"
              ></span>
            </b-button>
            <b-sidebar id="example-sidebar" shadow backdrop>
              <div class="px-3 py-2">
                <a href="#meterial" class="text-white"> MATERIALS </a><br />
                <a href="#product-configuration" class="text-white">
                  BUILD YOUR OWN </a
                ><br />
                <a href="#why-scancom" class="text-white"> WHY SCANCOM </a
                ><br />
                <a href="#frequent-questions" class="text-white"> FAQ </a><br />
              </div>
            </b-sidebar>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
window.onscroll = function () {
  scrollFunction();
};
function scrollFunction() {
  if (document.body.clientWidth > 600) {
    if (
      document.documentElement.scrollTop > 20 ||
      document.body.scrollTop > 20
    ) {
      document.getElementById("header").classList.add("small-height");
    } else {
      document.getElementById("header").classList.remove("small-height");
    }
  }
}

export default {
  computed: {
    authUser() {
      return this.$user.getters.authUser;
    },
  },
  methods: {
    logout() {
      this.$user.dispatch("logout").then(() => {
        let returnUrl = this.$router.currentRoute.fullPath;
        let query = returnUrl ? { returnUrl } : null;
        this.$router.push({ name: "Login", query });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
$font-size: 1.5rem;

.row {
  background: #e2e2e2;
  font-size: $font-size;
}
#header {
  background: #e2e2e2;

  &.small-height {
    #img-logo {
      padding: 0;
      max-height: 80px;
    }

    #menu-right {
      padding: 10px 35px;
    }
  }
}

#img-logo {
  padding: 20px 20px 0px 30px;
  max-width: 100%;
  height: 95%;
  margin: -0.5rem 0rem -1rem 3rem;
}
.font-size {
  font-size: 14px;
  color: #333;
  font-weight: bold;
  //letter-spacing: -0.01em;
}

#menu-right {
  padding-top: 40px;
  padding-right: 100px;
}

.intro-subtitle {
  text-shadow: 2px 2px 3px #000 !important;
}
.sticky-header.fixed {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  z-index: 1040;
  animation-duration: 0.4s;
  background-color: #e2e2e2;
  width: calc(100vw - 0.7rem);
}
@media screen and (max-width: 600px) {
  /* For mobile phones: */
  #img-logo {
    padding: 0;
    height: unset;
    max-height: 50px;
    margin: 0.2rem 0 0.5rem 0.5rem;
  }
  .btn-secondary {
    color: #fff;
    background-color: #6c757d;
    position: absolute;
    right: 1rem;
    bottom: 1rem;
  }
  div.menu {
    display: none;
  }
}

@media screen and (min-width: 600px) {
  div.menu-mobile {
    display: none;
    position: relative;
  }
}

.top-bar {
  background-color: #494949;
  color: #fff;
  padding: 0 1rem;
  font-size: 0.9rem;
  width: calc(100% - 1rem);
  @media screen and (max-width: 600px) {
    width: 100%;
  }

  a {
    color: #fff;
  }

  i {
    height: 1.5rem;
  }

  .tutorial {
    display: inline-block;
  }

  .account {
    position: relative;
    float: right;
  }
  .account .account-dropdown__list {
    display: none;
  }

  .account:hover .account-dropdown__list {
    display: inline-block;
  }

  .account-dropdown__list {
    position: absolute;
    right: 0;
    z-index: 2;
    text-align: left;
    top: 100%;
    min-width: 200px;
    padding: 10px 0;
    -webkit-transition: 0.3s;
    transition: 0.3s;
    background-color: #fff;
    -webkit-box-shadow: 0 1px 2px rgb(0 0 0 / 15%);
    box-shadow: 0 1px 2px rgb(0 0 0 / 15%);
  }

  .account-dropdown__list li {
    -webkit-transition: 0.3s;
    transition: 0.3s;
  }

  .account-dropdown__list li a {
    font-size: 14px;
    font-weight: 400;
    line-height: 14px;
    line-height: 1;
    display: block;
    padding: 8px 15px;
    color: #666;
  }
}
</style>

<style lang="scss">
.b-sidebar > .b-sidebar-body {
  -webkit-box-flex: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
  height: 100%;
  overflow-y: auto;
  background-color: darkgray;
}
.font-header {
  font-size: 10px;
}
.font-style-spp {
  font: normal 300 1.4rem/1.86 "Poppins", sans-serif;
  color: #333;
  font-size: 10px;
}
</style>
